// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hE","controlPlay":"hF","controlElement":"hG","lowerControlWrapper":"hH","lowerControlIconWrapper":"hI","lowerControlIcon":"hJ","show":"hK"};